import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAppointmentDrawerContext } from 'context/appointmentDrawerContext/AppointmentDrawerContainer'
import React, { useState } from 'react'
import { Client } from 'types/client'
import { User } from 'types/user'
const formInputData = [
    {
        id: 'firstNameId',
        name: 'first_name',
        value: '',
        isRequired: true,
        label: 'First Name',
        translationKey: 'first_name',
    },
    {
        id: 'lastNameId',
        name: 'last_name',
        value: '',
        isRequired: true,
        label: 'Last Name',
        translationKey: 'last_name',
    },
    {
        id: 'emailId',
        name: 'email',
        value: '',
        isRequired: true,
        label: 'Email',
        translationKey: 'email',
    },
    {
        id: 'phoneId',
        name: 'phone',
        value: '',
        isRequired: false,
        label: 'Phone',
        translationKey: 'phone',
    },
]
function AddNewClient() {
    const {
        setDisplayNewClientForm,
        setSelectedClient,
        selectedClient,
        setNewClientInfo,
    } = useAppointmentDrawerContext()
    const [client, setClient] = useState<
        Client | undefined
    >(undefined)

    const { translations } = useAppContext()

    const saveHandler = (value: Client) => {
        setSelectedClient(value)
        setNewClientInfo(value)
        setDisplayNewClientForm(false)
    }
    return (
        <div className="w-full border-2 border-gray-200 rounded-md bg-gray-200">
            <div className="flex flex-wrap w-full px-3 mt-4">
                {formInputData.map((currentInput) => (
                    <div
                        key={currentInput.id}
                        className="w-1/2 mb-3 flex flex-col pr-1 cursor-pointer"
                    >
                        <label
                            htmlFor={currentInput.id}
                            className="text-left"
                        >
                            {translations[currentInput?.translationKey]}
                            &nbsp;
                            {currentInput.isRequired ? (
                                <span className="text-red-500">*</span>
                            ) : (
                                ''
                            )}
                        </label>
                        <input
                            className="focus:ring-0 focus:border-primary-light py-2 rounded-md border-gray-300 focus:border-0 px-3"
                            name={currentInput.name}
                            id={currentInput.id}
                            onChange={(e) =>
                                {
                                    let user = client?.user || {} as User
                                    user = {...user, [e.target.name]: e.target.value} 
                                    setClient({...client, user})
                                }
                            }
                        />
                    </div>
                ))}
            </div>
            <div className="px-3 flex justify-end mb-2">
                <button
                    className="px-7 py-2 rounded-md border-2 border-gray-200 mr-2"
                    onClick={() => {
                        setDisplayNewClientForm(false)
                        setSelectedClient(undefined)
                    }}
                >
                    <Translation content_key="cancel" />
                </button>
                <button
                    className="px-7 py-2 rounded-md border-2 border-primary bg-primary text-white"
                    onClick={() =>
                        saveHandler(client as Client)
                    }
                >
                    <Translation content_key="save" />
                </button>
            </div>
        </div>
    )
}

export default AddNewClient
